import { render, staticRenderFns } from "./PaymentSystem.vue?vue&type=template&id=42a98c74&scoped=true"
import script from "./PaymentSystem.vue?vue&type=script&lang=js"
export * from "./PaymentSystem.vue?vue&type=script&lang=js"
import style0 from "./PaymentSystem.vue?vue&type=style&index=0&id=42a98c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a98c74",
  null
  
)

export default component.exports